import { render } from "./carRental.vue?vue&type=template&id=24b53a7c&scoped=true"
import script from "./carRental.vue?vue&type=script&lang=js"
export * from "./carRental.vue?vue&type=script&lang=js"

import "./carRental.vue?vue&type=style&index=0&id=24b53a7c&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b53a7c"]])

export default __exports__